module.exports = __webpack_public_path__ + "static/media/ERES_GANADOR_DEL_BINGO.5a7d956b.svg";